(() => {
  const clearStaleReturnIntent = () => queueMicrotask(() => {
    if (window.PK_PUP_CLUB_AUTH?.authenticated !== true) return;

    try {
      sessionStorage.removeItem("pk-next");
    } catch (_) {}

    try {
      localStorage.removeItem("pk-pup-club-return-v1");
    } catch (_) {}
  });

  window.addEventListener("pk:member-state", clearStaleReturnIntent);
  window.addEventListener("pk:auth-state", (event) => {
    if (event?.detail?.reason === "remote-session") clearStaleReturnIntent();
  });
})();
